var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main1"},[_c('div',{staticClass:"mainn"},[_c('div',{staticClass:"mleft"},[_vm._l((_vm.newsList),function(item){return _c('NewsItem',{key:item.id,attrs:{"data":item}})}),_c('Pagination',{attrs:{"totalPage":_vm.pageTotal,"changePageNumber":_vm.changePageNumber}})],2),_c('NewsCase')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }